import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/aboutHPPC/pic3_01.png'
import _imports_1 from '../../assets/aboutHPPC/pic4_02.png'
import _imports_2 from '../../assets/aboutHPPC/pic4_03.png'
import _imports_3 from '@/assets/aboutHPPC/reportLinkBtn.png'


const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"kv\"><div class=\"caption\"><h1>關於和平電力</h1></div></div><section class=\"sect1\"><div class=\"ctx\"><div class=\"sectTit\">全世界唯一港電廠循環經濟園區一份子</div><p>臺灣水泥股份有限公司於 1997 年與中電 (國際) 股份有限公司合資成立「和平電力股份有限公司」，於花蓮縣秀林鄉和平村設立和平電廠。它是台灣東部發電量最大的電廠，提供北部兩大重要城市 - 宜蘭約 95% 以及新北市約 20% 的用電需求，供應全台近 4% 的電力，目前更是台灣北東電網極為重要的供電來源。</p></div></section>", 2)
const _hoisted_3 = { class: "sect2" }
const _hoisted_4 = { class: "ctx" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<section class=\"sect3\"><div class=\"ctx\"><p>和平電廠位在和平工業區內，這是一個電廠、水泥廠與工業港融合在一起的「港電廠循環經濟園區」，電廠發電所需的煤炭 100% 採用密閉式儲存、運送，全程使用密閉式輸送帶。和平電廠也是全球唯一使用煤炭發電但卻未設置灰塘的火力發電廠，其他燃煤電廠中常見的露天堆存煤炭，在這邊完全看不到。</p><div class=\"tuo\"><div class=\"sign\"><img src=\"" + _imports_0 + "\"></div><div class=\"desp\"> 你一定好奇灰塘是什麼? 就是煤炭燃燒完後，產生大量煤灰，一般的火力發電廠會將煤灰投入海洋封圍填海，而和平電力則是透過全密閉輸送廊道將煤灰運至隔壁的台泥和平水泥廠作為原料，百分百完全再利用，所以不會有煤灰到海洋灰塘填海或被掩埋；而和平水泥廠每年也就近提供 6 萬噸的石灰石粉作為和平電廠的硫氧化物吸附劑，協助電廠降低 95％ 以上硫氧化物的排放，其反應後產生的脫硫石膏又成為水泥廠的主要原料之一。 </div></div><div class=\"left\"><div class=\"imgContainer3-1\"></div></div><div class=\"right\"><div class=\"imgContainer3-2\"><div class=\"imgTit\">和平電廠運煤輸送帶</div></div></div><div class=\"clear\"></div></div></section>", 1)
const _hoisted_6 = { class: "sect4" }
const _hoisted_7 = { class: "ctx" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "和電密碼", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "contOver" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "diagram",
    src: _imports_1
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "dist",
    src: _imports_2
  })
], -1)
const _hoisted_10 = { class: "specList" }
const _hoisted_11 = { class: "tit" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "spec" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "sect5" }
const _hoisted_16 = { class: "ctx" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "導入系統加強各項管理", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "台泥企業團致力成為全神貫注，處理人類文明與大自然之間複雜關係的綠色環境工程公司。和平電力秉持母公司永續經營的願景，全面導入 ISO 9001 品質管理、ISO 45001 職安衛管理、ISO 14001 環境管理及 ISO 50001 能源管理等，積極建立制度化的管理框架。", -1)
const _hoisted_19 = { class: "isoList" }
const _hoisted_20 = { class: "icon" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "txt" }
const _hoisted_23 = { class: "tit" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_27 = [
  _hoisted_26
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_big = _resolveComponent("big")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("article", null, [
      _hoisted_1,
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_swiper, {
            modules: _ctx.modules,
            "slides-per-view": 1,
            "space-between": 1,
            autoplay: {delay:3000, disableOnInteraction:false},
            speed: 1000,
            loop: true,
            pagination: {clickable:true},
            onSwiper: _ctx.onSwiper,
            onSlideChange: _ctx.onSlideChange,
            class: "swiper"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_swiper_slide, { class: "cover cover1" }),
              _createVNode(_component_swiper_slide, { class: "cover cover2" }),
              _createVNode(_component_swiper_slide, { class: "cover cover3" }),
              _createVNode(_component_swiper_slide, { class: "cover cover4" }),
              _createVNode(_component_swiper_slide, { class: "cover cover5" })
            ]),
            _: 1
          }, 8, ["modules", "onSwiper", "onSlideChange"])
        ])
      ]),
      _hoisted_5,
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specList, (row, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: idx
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("img", {
                    class: "icon",
                    src: _ctx.setPowerSpecIcon(row.icon)
                  }, null, 8, _hoisted_12),
                  _createTextVNode(" " + _toDisplayString(row.tit), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", {
                    innerHTML: row.spec
                  }, null, 8, _hoisted_14)
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iso, (row, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: idx
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("img", {
                    src: require(`@/assets/aboutHPPC/${row.icon}`)
                  }, null, 8, _hoisted_21)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_big, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.tit), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", {
                    innerHTML: row.desp
                  }, null, 8, _hoisted_24)
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("a", {
            href: _ctx.setUrl(_ctx.urlPath.aboutPowerReport)
          }, _hoisted_27, 8, _hoisted_25)
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}